"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Timer {
    constructor(runnable) {
        this.runnable = runnable;
        // Intentionally left empty
    }
    schedule(millisUntilStart) {
        this.handle = window.setTimeout(() => this.runnable(), millisUntilStart);
    }
    cancel() {
        if (this.handle) {
            window.clearTimeout(this.handle);
        }
    }
}
exports.default = Timer;
//# sourceMappingURL=Timer.js.map